// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TaxCodesTable: MarkdocTagRegistration = {
  tag: 'tax-codes-table',
  component: 'TaxCodesTable',
  render(node, config) {
    const taxProduct = (config.variables.taxProduct: any);
    return new Tag(this.tag, {entries: taxProduct?.tax_codes});
  },
};
